import { takeEvery, put, select, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as actionTypes from "constants/actionTypes";
import { trackEvent } from "actions/events";
import { selectAccountProfileAttribute } from "reducers/account/profileAttributes";
import { createProfileAttributeInFirebase } from "sagas/account/profileAttributes";

/*
 * Applies the specified changes to the segment in `account/profile-attributes`
 * reducer, then persists the new value to Firebase
 *
 * @param action
 */

function* updateProfileAttributeAndFlushProfileAttribute(action) {
  const { attributeId, changes } = action.payload;

  const profileAttribute = yield select(
    selectAccountProfileAttribute,
    attributeId
  );

  if (profileAttribute.source === "api") {
    yield call(createProfileAttributeInFirebase, {
      ...profileAttribute,
      ...changes,
      source: "firebase"
    });
  } else {
    yield put({
      type: actionTypes.UPDATE_PROFILE_ATTRIBUTE_IN_STORE,
      payload: {
        attributeId,
        changes
      }
    });

    yield put({
      type: actionTypes.FLUSH_PROFILE_ATTRIBUTE_TO_FIREBASE,
      payload: {
        attributeId
      }
    });
  }

  yield put(
    trackEvent("Updated a profileAttribute", {
      profile_attribute_id: attributeId
    })
  );
}

function* profileAttributes() {
  yield takeEvery(
    actionTypes.UPDATE_PROFILE_ATTRIBUTE_AND_FLUSH_PROFILE_ATTRIBUTE,
    updateProfileAttributeAndFlushProfileAttribute
  );
}

export default profileAttributes;
